import React from "react";
import PublicPageLayout from "./PublicPageLayout";

export default function About() {
  return (
    <PublicPageLayout
      title="讓運輸工作，更從容。"
      intro="Tallarge 專注在運輸現場真正需要的清楚、可靠與可追溯。"
    >
      <div className="public-page-list">
        <article className="public-page-row">
          <h2>從現場出發</h2>
          <p>把複雜的派工、路線與交付資訊，整理成團隊能直接使用的工作流程。</p>
        </article>
        <article className="public-page-row">
          <h2>資訊留在工作裡</h2>
          <p>重要的狀態、照片、聯絡資訊與簽收紀錄，都能回到同一筆工作中查看。</p>
        </article>
      </div>
    </PublicPageLayout>
  );
}
